import React from "react";
import { Grid } from "@mui/material";
import { Gap } from "../../atoms";

const SkeletonOverview = () => {
  return (
    <div className="skeleton-container">
      {/* Anggota Section */}
      <Grid container spacing={3}>
        {[1, 2, 3].map((i) => (
          <Grid item xs={12} sm={4} md={4} key={i}>
            <div className="skeleton-card">
              <div className="skeleton-line title"></div>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <div className="skeleton-line subtitle"></div>
                  <div className="skeleton-line value"></div>
                </Grid>
                <Grid item xs={6}>
                  <div className="skeleton-line subtitle"></div>
                  <div className="skeleton-line value"></div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        ))}
      </Grid>
      <Gap height={40} />
      {/* Chart Section */}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div className="skeleton-card chart">
            <div className="skeleton-line title"></div>
            <div className="skeleton-chart-box"></div>
          </div>
        </Grid>
      </Grid>
      <Gap height={40} />

      {/* Pengurus Section */}
      <div
        className="skeleton-line heading"
        style={{ width: "150px", height: "30px", marginBottom: "20px" }}
      ></div>
      <Grid container spacing={3}>
        {[1, 2, 3, 4].map((i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <div className="skeleton-card">
              <div className="skeleton-line subtitle"></div>
              <div
                className="skeleton-line value"
                style={{ width: "60%" }}
              ></div>
            </div>
          </Grid>
        ))}
      </Grid>
      <Gap height={40} />
      <div className="skeleton-card">
        <div
          className="skeleton-line subtitle"
          style={{ width: "200px", marginBottom: "20px" }}
        ></div>
        <Grid container spacing={3}>
          {[1, 2, 3, 4].map((i) => (
            <Grid item xs={6} sm={3} key={i}>
              <div className="skeleton-line subtitle"></div>
              <div
                className="skeleton-line value"
                style={{ width: "80%" }}
              ></div>
            </Grid>
          ))}
        </Grid>
      </div>

      <Gap height={40} />

      {/* Dokumen Section */}
      <div
        className="skeleton-line heading"
        style={{ width: "180px", height: "30px", marginBottom: "20px" }}
      ></div>
      <Grid container spacing={3}>
        {[1, 2].map((i) => (
          <Grid item xs={12} sm={6} md={6} key={i}>
            <div className="skeleton-card">
              <div className="skeleton-line subtitle"></div>
              <div
                className="skeleton-line value"
                style={{ width: "70%" }}
              ></div>
            </div>
          </Grid>
        ))}
      </Grid>
      <Gap height={40} />
      <div className="skeleton-card">
        <div
          className="skeleton-line subtitle"
          style={{ width: "180px", marginBottom: "20px" }}
        ></div>
        <Grid container spacing={3}>
          {[1, 2, 3, 4].map((i) => (
            <Grid item xs={6} sm={3} key={i}>
              <div className="skeleton-line subtitle"></div>
              <div
                className="skeleton-line value"
                style={{ width: "80%" }}
              ></div>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default SkeletonOverview;
